import "./style.css";

export const HeaderSkeleton = ({ style }) => (
  <div className='header skeleton-loader' style={style}/>
);